import script from "./deviceCheck.vue?vue&type=script&setup=true&lang=js"
export * from "./deviceCheck.vue?vue&type=script&setup=true&lang=js"

import "./deviceCheck.vue?vue&type=style&index=0&id=69c6e7b7&lang=less&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-69c6e7b7"]])

export default __exports__